/* Publish by EComposer at 2026-10-05 13:55:54*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-k22opgyzcd"]=  window.__ectimmers["ecom-k22opgyzcd"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-k22opgyzcd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k22opgyzcd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zf0x7pwnsw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zf0x7pwnsw', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3hvvpduc8lu"]=  window.__ectimmers["ecom-3hvvpduc8lu"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-3hvvpduc8lu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3hvvpduc8lu', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4t7fmopcfxl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4t7fmopcfxl', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-emayd1mw3t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-emayd1mw3t', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-spqbubbiuc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-spqbubbiuc', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s38c1m0klp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s38c1m0klp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9m7vqhm3ec').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9m7vqhm3ec', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-le5y4v4i6vp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-le5y4v4i6vp', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8e0ibj3rhdp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8e0ibj3rhdp', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-14dogffopawj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-14dogffopawj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ni8x0amfpmb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ni8x0amfpmb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8sej6bn89ut').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8sej6bn89ut', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-69lua6ijlsc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-69lua6ijlsc', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ve3wigvm4ud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ve3wigvm4ud', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-naif2suso4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-naif2suso4', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cg92rhlix8m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cg92rhlix8m', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zdhhjbk03u8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zdhhjbk03u8', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fi1g1ldxi1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fi1g1ldxi1', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-llfxbevssdl"]=  window.__ectimmers["ecom-llfxbevssdl"] || {};
if(!this.$el)return;const t=this.$el;if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelectorAll("[ecom-modal]");e.length&&new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}if(this.settings.link!=="lightbox"&&this.settings.link!=="custom"&&/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){let i=t.querySelector(".ecom-image-picture-hover"),o=t.querySelector(".ecom-image-picture.ecom-image-has-hover");if(!i||!o)return;i.addEventListener("click",function(){o.classList.add("image-active"),i.classList.add("image-hidden")}),o.addEventListener("click",function(){o.classList.remove("image-active"),i.classList.remove("image-hidden")})}

                    });
                    
                        document.querySelectorAll('.ecom-llfxbevssdl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-llfxbevssdl', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}